import React from 'react';
import { CircularProgress as MUICircularProgress } from '@mui/material';

const CircularProgress = (props) => {
  return (
    <MUICircularProgress {...props} />
  );
};

export default CircularProgress;
